/* AutoUlga storefront behaviour — variant picker, AJAX cart drawer with bundle upsell,
   sticky add-to-cart, gallery, mobile menu and collection colour filters. No dependencies. */
(() => {
  const AU = window.AutoUlga || { routes: {}, settings: {}, strings: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Money ---------- */
  function formatMoney(cents, format = AU.moneyFormat || '{{amount_with_comma_separator}} zł') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    const fmt = (n, decimals, thousands = ' ', decimal = ',') => {
      const fixed = (n / 100).toFixed(decimals);
      const [whole, frac] = fixed.split('.');
      const w = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? w + decimal + frac : w;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, ' ', ',');
      }
    });
  }
  const formatShort = (cents) => formatMoney(cents).replace(/[.,]00(?=\D*$)/, '');

  /* Honest bundle comparison: sum of the parts (same other options) vs the bundle price. */
  function bundleSavings(variants, variant) {
    const bundleValue = (AU.settings.bundleValue || 'Zestaw').trim();
    const parts = (AU.settings.bundleParts || 'Zagłówek, Lumbar').split(',').map((p) => p.trim()).filter(Boolean);
    if (!variant) return null;
    const idx = variant.options.indexOf(bundleValue);
    if (idx < 0 || !parts.length) return null;
    let total = 0;
    for (const part of parts) {
      const match = variants.find((v) => v.options.every((o, j) => (j === idx ? o === part : o === variant.options[j])));
      if (!match) return null;
      total += match.price;
    }
    if (total <= variant.price) return null;
    return { total, price: variant.price, saving: total - variant.price };
  }
  function renderSavings(el, info) {
    if (!el) return;
    el.hidden = !info;
    el.innerHTML = info
      ? `<span>Osobno: ${formatShort(info.total)}. W zestawie: ${formatShort(info.price)}.</span><b>Oszczędzasz ${formatShort(info.saving)}.</b>`
      : '';
  }

  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Cart API ---------- */
  const json = (r) => { if (!r.ok) return r.json().then((e) => Promise.reject(e)); return r.json(); };
  const cartApi = {
    get: () => fetch(AU.routes.cartJs, { headers: { Accept: 'application/json' } }).then(json),
    add: (items) => fetch(AU.routes.cartAdd, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items })
    }).then(json),
    change: (id, quantity) => fetch(AU.routes.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity })
    }).then(json)
  };
  const productCache = new Map();
  const getProduct = (handle) => {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(`${AU.routes.root.replace(/\/$/, '')}/products/${handle}.js`).then(json).catch(() => null));
    }
    return productCache.get(handle);
  };

  /* ---------- Variant picker ---------- */
  function setPrice(el, variant) {
    if (!el || !variant) return;
    const current = $('[data-au-price-current]', el);
    if (current) current.textContent = formatMoney(variant.price);
  }

  class BuyForm {
    constructor(form) {
      this.form = form;
      this.root = form.closest('[data-au-product-root]') || form;
      this.variants = JSON.parse($('[data-au-variants]', form)?.textContent || '[]');
      this.idInput = $('[data-au-variant-id]', form);
      this.addBtn = $('[data-au-add]', form);
      this.buyNowBtn = $('[data-au-buy-now]', form);
      this.error = $('[data-au-error]', form);
      form.addEventListener('change', (e) => { if (e.target.matches('[data-au-option-input]')) this.onOptionChange(); });
      form.addEventListener('submit', (e) => { e.preventDefault(); this.add(false); });
      this.buyNowBtn?.addEventListener('click', () => this.add(true));
      this.updateCardPrices();
    }
    selectedOptions() {
      return $$('[data-au-option]', this.form).map((fs) => $('input:checked', fs)?.value);
    }
    get variant() { return this.variants.find((v) => String(v.id) === this.idInput.value); }
    findVariant(options) { return this.variants.find((v) => v.options.every((o, i) => options[i] === undefined || o === options[i])); }
    onOptionChange() {
      const options = this.selectedOptions();
      let variant = this.findVariant(options);
      if (!variant) return this.setUnavailable();
      this.idInput.value = variant.id;
      $$('[data-au-option]', this.form).forEach((fs, i) => {
        const label = $('[data-au-option-label]', fs);
        if (label) label.textContent = options[i];
      });
      $$('[data-au-main-price]', this.root).forEach((el) => setPrice($('[data-au-price]', el) || el, variant));
      $$('[data-au-variant-text]', this.root).forEach((el) => { el.textContent = variant.title; });
      $$('[data-au-view-link]', this.root).forEach((a) => { a.href = `${a.href.split('?')[0]}?variant=${variant.id}`; });
      $$('[data-au-main-price] [data-au-savings]', this.root).forEach((el) => renderSavings(el, bundleSavings(this.variants, variant)));
      this.updateCardPrices();
      this.setAvailable(variant.available);
      if (this.root.hasAttribute('data-au-update-url')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      this.root.dispatchEvent(new CustomEvent('au:variant-change', { bubbles: true, detail: { variant } }));
    }
    updateCardPrices() {
      const options = this.selectedOptions();
      $$('[data-au-option]', this.form).forEach((fs, idx) => {
        $$('[data-au-card-price]', fs).forEach((holder) => {
          const opts = options.slice(); opts[idx] = holder.dataset.auCardPrice;
          const v = this.findVariant(opts);
          if (!v) return;
          setPrice($('[data-au-price]', holder), v);
          const sav = $('[data-au-savings]', holder.parentElement);
          if (sav) renderSavings(sav, bundleSavings(this.variants, v));
        });
      });
    }
    setAvailable(available) {
      const label = $('[data-au-add-label]', this.addBtn);
      [this.addBtn, this.buyNowBtn].forEach((b) => b && (b.disabled = !available));
      $$('[data-au-sticky-add]').forEach((b) => (b.disabled = !available));
      if (label) label.textContent = available ? this.addBtn.dataset.label : AU.strings.soldOut;
    }
    setUnavailable() {
      [this.addBtn, this.buyNowBtn].forEach((b) => b && (b.disabled = true));
      const label = $('[data-au-add-label]', this.addBtn);
      if (label) label.textContent = AU.strings.unavailable;
    }
    quantity() {
      const q = $('[data-au-qty-input]', this.root);
      return Math.max(1, parseInt(q?.value || '1', 10));
    }
    async add(buyNow) {
      if (this.error) this.error.textContent = '';
      const btn = buyNow ? this.buyNowBtn : this.addBtn;
      btn?.classList.add('is-loading');
      try {
        await cartApi.add([{ id: Number(this.idInput.value), quantity: this.quantity() }]);
        if (buyNow) { window.location.href = AU.routes.checkout; return; }
        const cart = await cartApi.get();
        drawer.render(cart);
        if (AU.settings.openDrawerOnAdd !== false) drawer.open();
      } catch (err) {
        if (this.error) this.error.textContent = (err && (err.description || err.message)) || AU.strings.addError;
      } finally {
        btn?.classList.remove('is-loading');
      }
    }
  }

  /* ---------- Variant media (hero + gallery) ---------- */
  function initMedia(root) {
    const slides = $$('[data-au-slide]', root);
    const thumbs = $$('[data-au-thumb]', root);
    if (!slides.length) return;
    const rail = $('[data-au-thumbs]', root);
    const counter = $('[data-au-slide-count]', root);
    let index = Math.max(0, slides.findIndex((s) => !s.hidden));
    const show = (id) => {
      const i = slides.findIndex((s) => s.dataset.auSlide === String(id));
      if (i < 0) return;
      index = i;
      slides.forEach((s, j) => (s.hidden = j !== i));
      thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.auThumb === String(id))));
      if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
      const thumb = thumbs.find((t) => t.dataset.auThumb === String(id));
      if (rail && thumb) {
        // Scroll only the rail (never the page) so the active thumbnail is visible.
        const vertical = rail.scrollHeight > rail.clientHeight;
        if (vertical) rail.scrollTo({ top: thumb.offsetTop - rail.clientHeight / 2 + thumb.offsetHeight / 2, behavior: 'smooth' });
        else rail.scrollTo({ left: thumb.offsetLeft - rail.clientWidth / 2 + thumb.offsetWidth / 2, behavior: 'smooth' });
      }
    };
    if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
    thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.auThumb)));
    $$('[data-au-step-slide]', root).forEach((b) => b.addEventListener('click', () => {
      const next = (index + Number(b.dataset.auStepSlide) + slides.length) % slides.length;
      show(slides[next].dataset.auSlide);
    }));
    $$('[data-au-rail]', root).forEach((b) => b.addEventListener('click', () => {
      if (rail) rail.scrollBy({ top: Number(b.dataset.auRail) * rail.clientHeight * 0.8, behavior: 'smooth' });
    }));
    // Swipe on the main image (mobile).
    const main = $('.au-gallery__main', root);
    if (main && slides.length > 1) {
      let x0 = null;
      main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) < 40) return;
        const next = (index + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
        show(slides[next].dataset.auSlide);
      });
    }
    root.addEventListener('au:variant-change', (e) => {
      const media = e.detail.variant && e.detail.variant.featured_media;
      if (media) show(media.id);
      $$('[data-au-sticky-thumb]').forEach((img) => {
        if (e.detail.variant.featured_image) img.src = e.detail.variant.featured_image.src + (e.detail.variant.featured_image.src.includes('?') ? '&' : '?') + 'width=120';
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  const drawer = {
    el: null, body: null, lastFocus: null,
    init() {
      this.el = $('[data-au-drawer]');
      if (!this.el) return;
      this.body = $('[data-au-drawer-body]', this.el);
      $$('[data-au-drawer-close]', this.el).forEach((b) => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.el.hasAttribute('open')) this.close(); });
      this.body.addEventListener('click', (e) => this.onBodyClick(e));
      this.body.addEventListener('change', (e) => {
        const input = e.target.closest('[data-au-line-qty]');
        if (input) this.change(input.dataset.key, parseInt(input.value, 10) || 0);
      });
      document.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-au-cart-open]');
        if (!opener) return;
        e.preventDefault();
        this.refresh().then(() => this.open());
      });
    },
    open() {
      if (!this.el) { window.location.href = AU.routes.cart; return; }
      this.lastFocus = document.activeElement;
      this.el.setAttribute('open', '');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('au-lock');
      $('.au-drawer__panel', this.el).focus();
    },
    close() {
      this.el.removeAttribute('open');
      this.el.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('au-lock');
      this.lastFocus?.focus?.();
    },
    async refresh() { const cart = await cartApi.get(); this.render(cart); return cart; },
    async change(key, quantity) {
      this.el.classList.add('is-busy');
      try { this.render(await cartApi.change(key, quantity)); } finally { this.el.classList.remove('is-busy'); }
    },
    onBodyClick(e) {
      const rm = e.target.closest('[data-au-line-remove]');
      if (rm) return this.change(rm.dataset.key, 0);
      const step = e.target.closest('[data-au-line-step]');
      if (step) {
        const input = $('[data-au-line-qty]', step.closest('.au-qty'));
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.auLineStep));
        return this.change(input.dataset.key, next);
      }
      const apply = e.target.closest('[data-au-upsell-apply]');
      if (apply && this.upsell) return this.applyUpsell();
    },
    render(cart) {
      $$('[data-au-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
      if (!this.el) return;
      const foot = $('[data-au-drawer-foot]', this.el);
      $('[data-au-cart-total]', this.el).textContent = formatMoney(cart.total_price);
      foot.hidden = cart.item_count === 0;
      if (!cart.items.length) {
        this.body.innerHTML = $('[data-au-empty-template]', this.el).innerHTML;
        return;
      }
      this.body.innerHTML = cart.items.map((it) => {
        const img = it.image ? `<img src="${esc(it.image)}${it.image.includes('?') ? '&' : '?'}width=200" alt="${esc(it.product_title)}" loading="lazy">` : '';
        const variant = it.product_has_only_default_variant ? '' : (it.variant_title || '');
        return `<div class="au-line">
          <a href="${esc(it.url)}" class="au-media au-media--cognac${img ? ' au-media--has-image' : ''}" style="--ratio:1/1">${img}</a>
          <div class="au-line__info">
            <div class="au-line__top"><b><a href="${esc(it.url)}">${esc(it.product_title)}</a></b><span class="au-line__total">${formatMoney(it.final_line_price)}</span></div>
            ${variant ? `<span class="au-line__variant">${esc(variant)}</span>` : ''}
            <div class="au-line__actions">
              <div class="au-qty au-qty--sm">
                <button type="button" data-au-line-step="-1" aria-label="−">−</button>
                <input type="number" min="0" value="${it.quantity}" data-au-line-qty data-key="${esc(it.key)}" aria-label="Ilość">
                <button type="button" data-au-line-step="1" aria-label="+">+</button>
              </div>
              <button type="button" class="au-line__remove" data-au-line-remove data-key="${esc(it.key)}">${esc(AU.strings.remove)}</button>
            </div>
          </div>
        </div>`;
      }).join('');
      this.renderUpsell(cart);
    },
    async renderUpsell(cart) {
      this.upsell = null;
      if (!AU.settings.upsellEnabled) return;
      const offer = await findUpsell(cart);
      if (!offer || !this.el) return;
      this.upsell = offer;
      const tpl = $('[data-au-upsell-template]', this.el);
      const wrap = document.createElement('div');
      wrap.innerHTML = tpl.innerHTML;
      const text = $('[data-au-upsell-text]', wrap);
      const diff = offer.target.price - offer.item.price;
      if (text) text.textContent = `${AU.strings.topUp} ${formatMoney(Math.max(0, diff))} · ${AU.strings.bundle} ${formatMoney(offer.target.price)}`;
      $('[data-au-upsell]', this.body)?.remove();
      this.body.append(...wrap.childNodes);
    },
    async applyUpsell() {
      const { item, target } = this.upsell;
      this.el.classList.add('is-busy');
      try {
        await cartApi.change(item.key, 0);
        await cartApi.add([{ id: target.id, quantity: item.quantity }]);
        await this.refresh();
      } finally { this.el.classList.remove('is-busy'); }
    }
  };

  async function findUpsell(cart) {
    const bundleValue = (AU.settings.bundleValue || '').trim();
    const bundleHandle = AU.settings.bundleProduct;
    for (const item of cart.items) {
      if (bundleHandle && item.handle === bundleHandle) continue;
      if (bundleValue && (item.options_with_values || []).some((o) => o.value === bundleValue)) continue;
      if (bundleValue) {
        const product = await getProduct(item.handle);
        if (product) {
          const idx = product.options.findIndex((o) => (o.values || []).includes(bundleValue));
          if (idx >= 0) {
            const target = product.variants.find((v) => v.available && v.options.every((o, j) => (j === idx ? o === bundleValue : o === item.variant_options[j])));
            if (target) return { item, target };
          }
        }
      }
      if (bundleHandle) {
        const bundle = await getProduct(bundleHandle);
        if (bundle) {
          const target = bundle.variants.find((v) => v.available && item.variant_options.some((o) => v.options.includes(o)))
            || bundle.variants.find((v) => v.available);
          if (target) return { item, target };
        }
      }
    }
    return null;
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky() {
    const bar = $('[data-au-sticky]');
    const trigger = $('[data-au-sticky-trigger]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;
    document.body.classList.add('au-has-sticky');
    const io = new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', String(!past));
    });
    io.observe(trigger);
    document.addEventListener('au:variant-change', (e) => {
      const v = e.detail.variant;
      $$('[data-au-sticky-variant]', bar).forEach((el) => (el.textContent = v.title));
      $$('[data-au-price]', bar).forEach((el) => setPrice(el, v));
    });
  }

  /* ---------- Header: hide on scroll down, show on scroll up ---------- */
  function initHeaderScroll() {
    const wrap = $('[data-au-header].au-header-wrap--sticky');
    const group = wrap && (wrap.closest('#header-group') || wrap.parentElement);
    if (!group || group.dataset.auScrollBound) return;
    group.dataset.auScrollBound = '1';
    const measure = () => document.documentElement.style.setProperty('--au-header-total', `${group.offsetHeight}px`);
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(group);
    let last = 0;
    let ticking = false;
    const onScroll = (e) => {
      const t = e.target;
      const scroller = t === document || t === document.documentElement || t === document.body ? null : t;
      // Only the page scrollers count (window on mobile, .page-wrapper on desktop) — not drawers or carousels.
      if (scroller && !scroller.classList?.contains('page-wrapper')) return;
      const y = scroller ? scroller.scrollTop : window.scrollY;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const delta = y - last;
        if (y <= group.offsetHeight) group.classList.remove('au-header-hidden');
        else if (delta > 4 && !document.documentElement.classList.contains('au-lock')) group.classList.add('au-header-hidden');
        else if (delta < 0) group.classList.remove('au-header-hidden');
        last = y;
        ticking = false;
      });
    };
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    group.addEventListener('focusin', () => group.classList.remove('au-header-hidden'));
  }

  /* ---------- Quantity steppers (product page) ---------- */
  function initSteppers() {
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-au-step]');
      if (!b) return;
      const input = $('[data-au-qty-input]', b.closest('.au-qty'));
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.auStep));
      $$('[data-au-qty-input]').forEach((other) => (other.value = input.value));
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    const menu = $('[data-au-menu]');
    if (!menu) return;
    const toggle = (open) => {
      menu.toggleAttribute('open', open);
      menu.setAttribute('aria-hidden', String(!open));
      document.documentElement.classList.toggle('au-lock', open);
    };
    $$('[data-au-menu-open]').forEach((b) => b.addEventListener('click', () => toggle(true)));
    $$('[data-au-menu-close]', menu).forEach((b) => b.addEventListener('click', () => toggle(false)));
  }

  /* ---------- Collection colour filter ---------- */
  function initFilters() {
    $$('[data-au-filters]').forEach((bar) => {
      const scope = bar.closest('[data-au-collection]') || document;
      const count = $('[data-au-count]', scope);
      bar.addEventListener('click', (e) => {
        const pill = e.target.closest('[data-au-filter]');
        if (!pill || pill.tagName === 'A') return;
        const key = pill.dataset.auFilter;
        $$('[data-au-filter]', bar).forEach((p) => p.classList.toggle('is-active', p === pill));
        let shown = 0;
        $$('[data-au-card]', scope).forEach((card) => {
          const ok = key === '*' || card.dataset.auColor === key;
          card.hidden = !ok;
          if (ok) shown++;
        });
        if (count) count.textContent = `${shown} ${shown === 1 ? 'produkt' : shown > 1 && shown < 5 ? 'produkty' : 'produktów'}`;
      });
    });
  }

  /* ---------- Product cards: colour choice inside the card ---------- */
  function initCardSwatches() {
    document.addEventListener('click', (e) => {
      const sw = e.target.closest('[data-au-card-swatch]');
      if (!sw) return;
      e.preventDefault();
      const card = sw.closest('[data-au-card]');
      $$('[data-au-card-swatch]', card).forEach((b) => b.setAttribute('aria-pressed', String(b === sw)));
      $$('[data-au-card-href]', card).forEach((a) => (a.href = sw.dataset.url));
      const img = $('.au-media img', card);
      if (img && sw.dataset.img) { img.src = sw.dataset.img; img.removeAttribute('srcset'); }
      const label = $('[data-au-card-color]', card);
      if (label) label.textContent = sw.dataset.name;
    });
  }

  /* ---------- Video play ---------- */
  function initVideo() {
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-au-play]');
      if (!b) return;
      const video = $('video', b.parentElement);
      if (video) { video.controls = true; video.play(); b.hidden = true; }
    });
  }

  const initSection = (root = document) => {
    $$('[data-au-buy]', root).forEach((f) => new BuyForm(f));
    $$('[data-au-product-root]', root).forEach(initMedia);
    if (root.matches?.('[data-au-product-root]')) initMedia(root);
  };
  const boot = () => {
    drawer.init();
    initSection();
    initSticky();
    initSteppers();
    initMenu();
    initFilters();
    initVideo();
    initCardSwatches();
    initHeaderScroll();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme editor: re-bind only the reloaded section (global listeners are delegated and stay bound).
  document.addEventListener('shopify:section:load', (e) => {
    initSection(e.target);
    if ($('[data-au-menu]', e.target)) initMenu();
    if ($('[data-au-filters]', e.target)) initFilters();
    if ($('[data-au-sticky]', e.target)) initSticky();
    if ($('[data-au-header]', e.target)) initHeaderScroll();
  });

  window.AutoUlga.formatMoney = formatMoney;
  window.AutoUlga.drawer = drawer;
})();


/* ==========================================================================
   v8 (2026-09-28): Judge.me reviews — carousel (home) / list (product page).
   Source: Judge.me storefront endpoint for this product. Nothing hard-coded:
   no names (shown as the editable "buyer" label), no dates, no "verified" badges.
   Cards are only built for reviews with real text; rating-only imports (text = product
   title or empty) are counted and reported, never shown as fake quotes. No rating filter.
   ========================================================================== */
(() => {
  const ENDPOINT = 'https://cdn.judge.me/widgets/reviews_grid_widget_data';
  const $ = (s, r = document) => r.querySelector(s);
  const norm = (t) => String(t || '').trim().toLowerCase().replace(/\s+/g, ' ');

  async function getJson(url, tries = 3) {
    for (let i = 0; i < tries; i++) {
      try {
        const r = await fetch(url, { credentials: 'omit' });
        if (r.ok) return await r.json();
      } catch (e) { /* retry */ }
      await new Promise((ok) => setTimeout(ok, 400 * (i + 1)));
    }
    throw new Error('Judge.me request failed');
  }

  async function fetchAll(productId, shop) {
    const url = (page) => ENDPOINT + '?' + new URLSearchParams({
      page: String(page), per_page: '24', show_media_only: 'false', display_order: 'most_recent',
      review_selection: 'current_product', product_id: productId, shop_domain: shop, platform: 'shopify'
    });
    const first = await getJson(url(1));
    let reviews = first.reviews || [];
    const pages = Math.min(first.total_pages || 1, 20);
    for (let p = 2; p <= pages; p++) reviews = reviews.concat((await getJson(url(p))).reviews || []);
    return reviews;
  }

  function split(reviews, productTitle) {
    const titleKey = norm(productTitle);
    const seen = new Set();
    const withText = [];
    let ratingOnly = 0;
    for (const r of reviews) {
      const key = norm(r.body);
      const own = norm(r.product_title);
      if (!key || key === titleKey || (own && key === own)) { ratingOnly++; continue; }
      if (seen.has(key)) continue; // identical text imported twice
      seen.add(key);
      withText.push(r);
    }
    // Reviews with a customer photo first (they are rare), otherwise Judge.me's own order.
    const withTextIds = new Set(withText.map((r) => r.uuid));
    return {
      cards: withText.filter((r) => r.pictures_urls && r.pictures_urls.length).concat(withText.filter((r) => !(r.pictures_urls && r.pictures_urls.length))),
      // Full list for the product page: every rating in Judge.me's order; text only where it is real and first.
      all: reviews.map((r) => ({ r, text: withTextIds.has(r.uuid) })),
      ratingOnly
    };
  }

  // Review date from Judge.me (the original review date — verified against AliExpress), dd.mm.rrrr.
  function reviewDate(iso, label) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    if (!m || !label) return '';
    return label.replace('[data]', m[3] + '.' + m[2] + '.' + m[1]);
  }

  // Polish plural for ratings: 1 ocena · 2–4 oceny · 5+ ocen (12–14 → ocen).
  function ratingsWord(n) {
    const m10 = n % 10, m100 = n % 100;
    if (n === 1) return '1 ocena';
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return n + ' oceny';
    return n + ' ocen';
  }

  // Product-page row (design): avatar circle, buyer label, stars; quote and photo thumbnail when present.
  function listRow(r, root, withText) {
    const row = document.createElement('figure');
    const pic = r.pictures_urls && r.pictures_urls[0];
    row.className = 'au-review-row au-jm__lrow' + (withText || pic ? '' : ' au-jm__lrow--compact');
    const main = document.createElement('div');
    main.className = 'au-jm__lmain';
    const author = document.createElement('div');
    author.className = 'au-author';
    const avatar = document.createElement('span');
    avatar.className = 'au-avatar';
    avatar.setAttribute('aria-hidden', 'true');
    const tpl = root.querySelector('template[data-au-jm-avatar]');
    if (tpl) avatar.appendChild(tpl.content.cloneNode(true));
    author.appendChild(avatar);
    const who = document.createElement('div');
    who.className = 'au-jm__who';
    const b = document.createElement('b');
    b.textContent = root.dataset.buyer || '';
    who.appendChild(b);
    who.appendChild(stars(r.rating));
    const when = reviewDate(r.created_at, root.dataset.dateLabel);
    if (when) {
      const t = document.createElement('time');
      t.className = 'au-jm__date';
      t.dateTime = String(r.created_at).slice(0, 10);
      t.textContent = when;
      who.appendChild(t);
    }
    author.appendChild(who);
    main.appendChild(author);
    if (withText) {
      const translated = TRANSLATIONS.get(r.uuid);
      const q = document.createElement('blockquote');
      q.className = 'au-jm__quote';
      q.textContent = '„' + (translated || String(r.body).trim()) + '”';
      if (!translated) q.lang = 'en';
      main.appendChild(q);
    }
    row.appendChild(main);
    if (pic) {
      const photos = document.createElement('div');
      photos.className = 'au-review-row__photos';
      const m = document.createElement('div');
      m.className = 'au-media au-media--has-image';
      m.style.setProperty('--ratio', '1 / 1');
      const img = document.createElement('img');
      img.src = pic.compact || pic.small || pic.original;
      img.alt = root.dataset.photoAlt || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 240; img.height = 240;
      m.appendChild(img);
      photos.appendChild(m);
      row.appendChild(photos);
    }
    return row;
  }

  // Editable translations from Theme settings → Duxen → "Tłumaczenia opinii" (uuid = text per line).
  const TRANSLATIONS = (() => {
    const map = new Map();
    const raw = (window.AutoUlga && window.AutoUlga.settings && window.AutoUlga.settings.reviewTranslations) || '';
    raw.split(/\r?\n/).forEach((line) => {
      const i = line.indexOf('=');
      if (i < 1) return;
      const id = line.slice(0, i).trim();
      const text = line.slice(i + 1).trim();
      if (id && text) map.set(id, text);
    });
    return map;
  })();

  function stars(rating) {
    const wrap = document.createElement('span');
    wrap.className = 'au-jm__stars';
    const n = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', n + '/5');
    wrap.innerHTML = '★★★★★'.split('').map((c, i) => '<span class="' + (i < n ? 'on' : 'off') + '">' + c + '</span>').join('');
    return wrap;
  }

  function card(r, root) {
    const el = document.createElement('figure');
    el.className = 'au-jm__card';
    el.appendChild(stars(r.rating));
    const pic = r.pictures_urls && r.pictures_urls[0];
    if (pic) {
      const media = document.createElement('div');
      media.className = 'au-jm__photo';
      const img = document.createElement('img');
      img.src = pic.compact || pic.small || pic.original;
      img.alt = root.dataset.photoAlt || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 400; img.height = 400;
      media.appendChild(img);
      el.appendChild(media);
    }
    const translated = TRANSLATIONS.get(r.uuid);
    const q = document.createElement('blockquote');
    q.className = 'au-jm__text';
    q.textContent = '„' + (translated || String(r.body).trim()) + '”';
    if (!translated) q.lang = 'en';
    el.appendChild(q);
    const by = document.createElement('figcaption');
    by.className = 'au-jm__by';
    by.textContent = root.dataset.buyer || '';
    el.appendChild(by);
    return el;
  }

  async function init(root) {
    if (root.dataset.auJmReady) return;
    root.dataset.auJmReady = '1';
    const track = $('[data-au-jm-track]', root);
    let data;
    try {
      data = split(await fetchAll(root.dataset.productId, root.dataset.shop), root.dataset.productTitle);
    } catch (e) {
      console.warn('AutoUlga: Judge.me reviews unavailable', e);
      if (root.dataset.layout !== 'list') root.hidden = true;
      return;
    }
    root.dataset.auJmShown = String(data.cards.length);

    if (root.dataset.layout === 'list') {
      // Every rating from Judge.me. Rows with text or a photo first, then the rest; newest date first in both.
      const hasPic = (r) => !!(r.pictures_urls && r.pictures_urls.length);
      const byDate = (a, b) => String(b.r.created_at || '').localeCompare(String(a.r.created_at || ''));
      const isEmpty = (r) => { const k = norm(r.body); return !k || k === norm(root.dataset.productTitle) || k === norm(r.product_title); };
      const rich = data.all.filter((it) => it.text || hasPic(it.r)).sort(byDate);
      const rest = data.all.filter((it) => !(it.text || hasPic(it.r))).sort(byDate);
      // Mode B: truly empty ratings collapse into one expandable row; everything else stays a normal row.
      const modeB = root.dataset.plainMode === 'b';
      const collapsed = modeB ? rest.filter((it) => isEmpty(it.r)) : [];
      const items = rich.concat(modeB ? rest.filter((it) => !isEmpty(it.r)) : rest);
      root.dataset.auJmShown = String(items.length + collapsed.length);
      const size = Math.max(1, parseInt(root.dataset.pageSize, 10) || 6);
      const more = $('[data-au-jm-more]', root);
      const group = $('[data-au-jm-collapsed]', root);
      let shown = 0;
      const next = () => {
        items.slice(shown, shown + size).forEach((it) => track.appendChild(listRow(it.r, root, it.text)));
        shown = Math.min(shown + size, items.length);
        if (more) more.hidden = shown >= items.length;
        track.dataset.rows = String(track.children.length);
        if (group && collapsed.length) group.hidden = shown < items.length; // after the other rows
      };
      if (group && collapsed.length) {
        const toggle = $('[data-au-jm-collapsed-toggle]', group);
        const inner = $('[data-au-jm-collapsed-rows]', group);
        toggle.querySelector('[data-label]').textContent = (root.dataset.collapsedLabel || '').replace('[liczba]', ratingsWord(collapsed.length));
        toggle.addEventListener('click', () => {
          const open = toggle.getAttribute('aria-expanded') === 'true';
          if (!open && !inner.children.length) collapsed.forEach((it) => inner.appendChild(listRow(it.r, root, false)));
          toggle.setAttribute('aria-expanded', String(!open));
          inner.hidden = open;
        });
      }
      next();
      more && more.addEventListener('click', next);
      return;
    }

    // Carousel: hidden entirely when there is nothing with text to show.
    if (!data.cards.length) { root.hidden = true; return; }
    data.cards.forEach((r) => track.appendChild(card(r, root)));
    root.hidden = false;
    track.dispatchEvent(new CustomEvent('au:jm-rendered', { bubbles: true }));
    const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 320; };
    const prev = $('[data-au-jm-prev]', root), nxt = $('[data-au-jm-next]', root);
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (nxt) nxt.disabled = track.scrollLeft >= max;
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    nxt && nxt.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    requestAnimationFrame(sync);
  }

  const boot = (scope = document) => {
    const roots = Array.from(scope.querySelectorAll('[data-au-jm]'));
    if (!roots.length) return;
    const start = () => roots.forEach(init);
    // Below-the-fold content: wait until the page is idle, but load right away if the section is near.
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); init(e.target); } }), { rootMargin: '800px 0px' });
      roots.forEach((r) => (r.hidden ? init(r) : io.observe(r)));
    } else start();
  };

  // Rating link in the product hero → smooth scroll to the review list (works with Horizon's scroller).
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-au-scroll-to]');
    if (!a) return;
    const target = document.getElementById(a.dataset.auScrollTo);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();


/* ==========================================================================
   v12 (2026-09-29): phone-only carousels (≤749px). Desktop/tablet are untouched: nothing below runs
   or changes the DOM above 749px, and leaving the phone width removes every clone again.

   swipe  — "AU · Detale materiału", "AU · Opinie Judge.me" (carousel): native horizontal scrolling
            (so vertical page scrolling keeps working), active card centred with neighbours peeking,
            infinite: a copy of the set on each side, silently re-centred after scrolling stops.
   auto   — "W twoim aucie" (home), "Jak dobrać kolor" (collection): slow continuous scroll to the right,
            infinite. Any touch / swipe / wheel / focus pauses it; it resumes after 5 s without interaction.
            Movement is a sub-pixel translate3d on the cards (GPU-composited); on pause the offset is handed
            over to the native scroll position so the finger continues exactly where the cards are.
            No motion at all with prefers-reduced-motion, off-screen or in a background tab.
   ========================================================================== */
(() => {
  const PHONE = window.matchMedia('(max-width: 749px)');
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  const SPEED = 24;        // px per second — calm
  const IDLE_MS = 5000;    // resume after 5 s without interaction

  class Loop {
    constructor(track, mode) {
      this.track = track;
      this.mode = mode;
      this.on = false;
      this.touching = false;
      this.visible = true;
      this.idleTimer = null;
      this.settleTimer = null;
      this.onScroll = this.onScroll.bind(this);
      this.tick = this.tick.bind(this);
      this.pause = this.pause.bind(this);
      this.release = this.release.bind(this);
    }

    enable() {
      if (this.on) return;
      const originals = Array.from(this.track.children).filter((c) => !c.hasAttribute('data-au-clone'));
      if (originals.length < 2) return;
      this.on = true;
      this.originals = originals;
      const mk = (el) => {
        const c = el.cloneNode(true);
        c.setAttribute('data-au-clone', '');
        c.setAttribute('aria-hidden', 'true');
        c.inert = true;
        c.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
        return c;
      };
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();
      originals.forEach((el) => { before.appendChild(mk(el)); after.appendChild(mk(el)); });
      this.track.insertBefore(before, this.track.firstChild);
      this.track.appendChild(after);
      this.track.setAttribute('data-au-loop', this.mode);
      requestAnimationFrame(() => {
        this.measure();
        this.jumpTo(this.home());
      });
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if ('onscrollend' in window) {
        this.onScrollEnd = () => { if (!this.touching) this.normalise(); };
        this.track.addEventListener('scrollend', this.onScrollEnd);
      }
      // Never re-centre while a finger is on the carousel; do it once the gesture and momentum are over.
      this.onTouchStart = () => { this.touching = true; };
      this.onTouchEnd = () => { this.touching = false; clearTimeout(this.settleTimer); this.settleTimer = setTimeout(() => this.normalise(), 350); };
      this.track.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.track.addEventListener('touchend', this.onTouchEnd, { passive: true });
      this.track.addEventListener('touchcancel', this.onTouchEnd, { passive: true });
      if (this.mode === 'auto') this.enableAuto();
    }

    disable() {
      if (!this.on) return;
      this.on = false;
      this.stopAuto();
      this.track.removeEventListener('scroll', this.onScroll);
      this.track.removeEventListener('touchstart', this.onTouchStart);
      this.track.removeEventListener('touchend', this.onTouchEnd);
      this.track.removeEventListener('touchcancel', this.onTouchEnd);
      if (this.onScrollEnd) this.track.removeEventListener('scrollend', this.onScrollEnd);
      this.track.querySelectorAll(':scope > [data-au-clone]').forEach((c) => c.remove());
      this.track.removeAttribute('data-au-loop');
      this.track.scrollLeft = 0;
    }

    // Width of one full set of cards (distance from an original to its clone after the set).
    measure() {
      const first = this.originals[0];
      const clone = this.track.children[this.originals.length * 2];
      this.setWidth = clone.offsetLeft - first.offsetLeft;
    }

    // Scroll position that shows the first original card (centred for swipe, start for auto).
    home() {
      const first = this.originals[0];
      if (this.mode === 'swipe') return first.offsetLeft - (this.track.clientWidth - first.offsetWidth) / 2;
      return first.offsetLeft - parseFloat(getComputedStyle(this.track).paddingLeft || 0);
    }

    jumpTo(x) {
      const prev = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = x;
      this.track.style.scrollBehavior = prev;
      this.pos = this.track.scrollLeft;
    }

    // Keep the view inside the middle set: shift by exactly one set width (content is identical).
    normalise() {
      if (!this.on || !this.setWidth) return;
      const start = this.home();
      const x = this.track.scrollLeft;
      if (x < start - this.setWidth / 2) this.jumpTo(x + this.setWidth);
      else if (x > start + this.setWidth / 2) this.jumpTo(x - this.setWidth);
    }

    onScroll() {
      if (this.mode === 'auto' && this.running) return; // our own movement
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => { if (!this.touching) this.normalise(); }, 160);
      if (this.mode === 'auto') this.scheduleResume();
    }

    /* ---------- auto mode ---------- */
    enableAuto() {
      const t = this.track;
      ['pointerdown', 'touchstart', 'wheel', 'focusin', 'keydown'].forEach((e) => t.addEventListener(e, this.pause, { passive: true }));
      ['pointerup', 'pointercancel', 'touchend', 'touchcancel', 'focusout'].forEach((e) => t.addEventListener(e, this.release, { passive: true }));
      this.io = new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; this.visible ? this.startRun() : this.stopRun(); });
      this.io.observe(t);
      this.onVis = () => (document.hidden ? this.stopRun() : this.startRun());
      document.addEventListener('visibilitychange', this.onVis);
      this.startRun();
    }

    stopAuto() {
      const t = this.track;
      this.stopRun();
      clearTimeout(this.idleTimer);
      ['pointerdown', 'touchstart', 'wheel', 'focusin', 'keydown'].forEach((e) => t.removeEventListener(e, this.pause));
      ['pointerup', 'pointercancel', 'touchend', 'touchcancel', 'focusout'].forEach((e) => t.removeEventListener(e, this.release));
      if (this.io) this.io.disconnect();
      if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
    }

    canRun() { return this.on && !this.touching && !this.idle && this.visible && !document.hidden && !REDUCED.matches; }

    // The native scroll position stays put while running; the cards move by a fractional translate3d
    // (--au-shift). Rounded scrollLeft steps (0.4 px/frame → whole pixels every 2–3 frames) were the jerk.
    startRun() {
      if (this.running || !this.canRun()) return;
      this.running = true;
      this.base = this.track.scrollLeft;
      this.shift = 0;
      this.homeX = this.home();
      this.track.classList.add('is-au-running');
      this.last = performance.now();
      this.raf = requestAnimationFrame(this.tick);
    }

    stopRun() {
      if (!this.running) return;
      this.running = false;
      cancelAnimationFrame(this.raf);
      // Hand the visual offset over to the real scroll position (no visible jump).
      const total = this.base + this.shift;
      this.track.style.setProperty('--au-shift', '0px');
      this.track.classList.remove('is-au-running');
      this.jumpTo(total);
    }

    tick(now) {
      if (!this.running) return;
      const dt = Math.min(0.1, (now - this.last) / 1000);
      this.last = now;
      this.shift += SPEED * dt;
      if (this.setWidth && this.base + this.shift > this.homeX + this.setWidth) this.shift -= this.setWidth; // seamless wrap
      this.track.style.setProperty('--au-shift', (-this.shift).toFixed(2) + 'px');
      this.raf = requestAnimationFrame(this.tick);
    }

    // Touch / swipe / wheel / focus: stop now; resume only after 5 s without further interaction.
    pause(e) {
      if (e && e.type === 'touchstart') this.touching = true;
      this.idle = true;
      this.stopRun();
      clearTimeout(this.idleTimer);
    }

    release(e) {
      if (e && (e.type === 'touchend' || e.type === 'touchcancel')) this.touching = false;
      this.scheduleResume();
    }

    scheduleResume() {
      clearTimeout(this.idleTimer);
      this.idle = true;
      this.idleTimer = setTimeout(() => {
        this.idle = false;
        this.normalise();
        this.startRun();
      }, IDLE_MS);
    }
  }

  const loops = new Map();
  const targets = (scope) => [
    ...Array.from(scope.querySelectorAll('.au-mat__grid')).map((el) => [el, 'swipe']),
    ...Array.from(scope.querySelectorAll('.au-jm--carousel [data-au-jm-track]')).map((el) => [el, 'swipe']),
    ...Array.from(scope.querySelectorAll('.au-cabins .au-cabins__grid, .au-color-guide .au-cabins__grid')).map((el) => [el, 'auto']),
  ];

  function apply(scope = document) {
    targets(scope).forEach(([el, mode]) => {
      let loop = loops.get(el);
      if (!loop) { loop = new Loop(el, mode); loops.set(el, loop); }
      if (PHONE.matches) loop.enable(); else loop.disable();
    });
  }

  PHONE.addEventListener('change', () => apply());
  REDUCED.addEventListener('change', () => loops.forEach((l) => (REDUCED.matches ? l.stopRun() : l.startRun())));
  // Review cards arrive asynchronously from Judge.me.
  document.addEventListener('au:jm-rendered', (e) => apply(e.target.closest('.au-jm') || document));
  window.addEventListener('resize', () => loops.forEach((l) => { if (l.on) { l.measure(); l.normalise(); } }));
  document.addEventListener('shopify:section:load', (e) => apply(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => apply()); else apply();
})();
